export function getRankingListData(data, nameKey, valueKey, unit = "-") {
  return data.map((item) => {
    const { [nameKey]: transformName, [valueKey]: transformValue, ...rest } = item;

    return {
      ...rest,
      name: transformName,
      value: transformValue,
      unit,
    };
  });
}
